// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"bn-z","badgeLink":"cn-z","category":"dn-z"};